import Column from '@app/components/layout/Column'
import { DataCard } from './DataCard'
import { useMemo } from 'react'
import { ViewEventModel } from 'functions/app/event/view'
import defaultProjectPicture from '@app/assets/defaultProjectPicture.png'
import { PageMediaGallery } from '@app/components/blocks/mediaGallery/PageMediaGallery'

export const RightColumn = ({ event }: { event: ViewEventModel }) => {
  const eventImages = useMemo(() => {
    const images = event?.images ?? []
    return images.map((image) => image.src)
  }, [event?.images])

  return (
    <Column
      gap="2.5rem"
      alignItems="stretch"
      style={{ flex: '1 1 23rem', minWidth: '23rem' }}
    >
      <PageMediaGallery
        title={event.title}
        images={eventImages}
        defaultImage={defaultProjectPicture}
        style={{ width: '100%' }}
      />
      <DataCard event={event} />
    </Column>
  )
}
